export const buildId = process.env.NEXT_PUBLIC_BUILD_ID as string

export const appName = 'angel-web'

export const SUPPRESSED_THEATRICAL_FUNNEL_PROJECT_SLUGS = ['homestead']
